/**
 * 埋点常用事件
 * 常用的有view_material，click_material，$AppViewScreen，$pageview, $AppStart。
 * 'view_material'=========曝光事件
 * 'click_material'========点击事件
 * '$AppViewScreen'========浏览事件（包含h5和原生页面的浏览事件，其中$referrer字段和url字段分别记录上一页和当前页面的链接信息）
 * '$pageview'=============h5浏览事件（现在浏览事件暂时都使用的$AppViewScreen）
 * '$AppStart'=============启动事件
 */
import MobileDetect from './mobile-detect.min.js';

export default {
  /**
   *埋点公共数据
  */
  register() {
    return {
      // time: new Date().getTime(),
      lib: '',
      // 操作系统
      $os: this.detectOS()[1],
      // 操作系统版本号
      $os_version: this.detectOS()[1],
      // 运营商
      $carrier: '',
      // 手机品牌
      $manufacturer: this.detectOS()[2],
      // 手机型号
      $model: this.detectOS()[0],
      // 网络类型
      $network_type: this.getNetworkType()[0],
      // app版本号
      $app_version: '',
      // 是否为WIF
      $wifi: this.getNetworkType()[0] == 'wifi' ? true : false,
      // IP
      ip: sessionStorage.getItem('ip')?sessionStorage.getItem('ip'):'',
      // 库文件版本
      $lib_version: '',
      // 神策用户ID，以手机设备来区分，不管用户是否登陆聚美，都会生成一个user_id，一个设备信息，对应一个user_id（现在统计UV，是根据distinct user_id）
      uid: '',
      // 当前链接(native可能是类、controller、url scheme,H5和Web直接是link)
      $url: '',
      // 来源URL
      $referrer: '',
      // app外部来源
      source: '',
      // Android唯一标识
      utdid: '',
      // Android设备号
      imei: '',
      // iOS设备号
      idfa: '',
      // iOS广告设备号
      idfv: '',
      // AB测试用户组
      ab_group: '',
    };
  },
 
  pageview(parms) {
    return {
      $url: location.href,
      $referrer: parms.referrer ? parms.referrer : document.referrer,
      page_type: parms.page_type,
      referrer_page_type: sessionStorage.getItem("pageType") ? sessionStorage.getItem("pageType") : '',
      page_attr: parms.page_attr ? parms.page_attr : '',
      item_id: parms.item_id,
      item_type: parms.item_type,
      sell_type: parms.sell_type,
      sell_label: parms.sell_label,
      platform: parms.platform ? parms.platform : 'h5',
      // is_return: parms.is_return==='1',
    }
  },
 
  material(parms) {
    return {
      //平台
      platform: parms.platform ? parms.platform : 'h5',
      // 页面标识
      page_type: parms.page_type,
      // 当前页面地址
      current_page_url: location.href,
      // 连锁id
      page_attr: parms.page_attr ? parms.page_attr : '',
      // 页面内容id
      item_id: parms.item_id,
      // 页面内容类型
      item_type: parms.item_type,
      //
      sell_from: parms.sell_from,
      // 销售来源值
      sell_label: parms.sell_label,
      // 销售来源类型
      sell_type: parms.sell_type,
      // 卡片类型
      card_type: parms.card_type ? parms.card_type : '',
      // 卡片位置
      card_position: parms.card_position ? parms.card_position.toString() : '',
      // 卡片ID
      card_id: parms.card_id ? parms.card_id : '',
      // material素材id
      material_id: parms.material_id ? parms.material_id : '',
      // material素材类型
      material_type: parms.material_type,
      // 素材链接地址
      material_link: parms.material_link ? parms.material_link : '',
      // 素材名称
      material_name: '',
      // 素材参数
      material_attr: parms.material_attr ? parms.material_attr : '',
      // 素材关联id
      material_item_id: parms.material_item_id ? parms.material_item_id : '',
      // 素材关联类型
      material_item_type: parms.material_item_type ? parms.material_item_type : '',
      //  素材位置
      material_position: parms.material_position ? parms.material_position.toString() : '',
      params: parms.params ? parms.params : ''
    }
  },

  /**
  * 触发埋点方法
  * @param type 事件名称
  * @param parms 自定义字段
  */
  send(type, parms) {
    // 公共数据 静态公共属性
    sensors.registerPage(this.register());
    // 自定义数据
    sensors.track(type, this.material(parms));
  },

  /**
  * 使用 sensors.login 完成用户标识的注册
  * @param memberId
  */
  sendLogin(memberId) {
    sensors.registerPage(this.register());
    sensors.login(memberId);
    return [memberId]
  },
 
  /**
  * 使用 sensors.logout 切换到之前的匿名 id
  */
  logout() {
    sensors.logout();
  },
  /**
  * 浏览页面事件
  * @param type 事件名称
  * @param parms 自定义字段
  */
  view(type, parms) {
    sensors.registerPage(this.register());
    // 自定义数据
    sensors.track(type, this.pageview(parms));
  },
 
  /**
  * 页面曝光事件
  * @param element element为id
  * @param type 事件名称
  * @param parms 自定义字段
  */
  load(element, type, parms) {
    sensors.registerPage(this.register());
    var settime;
    var el = document.getElementById(element);
    console.log('el',el);
    if (el) {
      var io = new IntersectionObserver(
        entries => {
          // 执行中断
          clearTimeout(settime);
          // 等待1秒执行 若不到1秒会中断
          if (entries[0].isIntersecting) {
            settime = setTimeout(() => {
              this.send(type, this.material(parms));
            }, 1000)
          }
        }, {}
      );
      io.observe(el);
    }
  },
 
  /**
  * 获取手机的操作系统和版本号
  */
  detectOS() {
    //判断数组中是否包含某字符串
    var ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      Array.prototype.contains = function (needle) {
        for (i in this) {
          if (this[i].indexOf(needle) > 0) return i;
        }
        return -1;
      };
      var device_type = navigator.userAgent;//获取userAgent信息
      var md = new MobileDetect(device_type);//初始化mobile-detect
      var os = md.os();//获取系统
      var mf = md.mobile()
      var model = "";
      if (os === "iOS") {//ios系统的处理
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os === "AndroidOS") {//Android系统的处理
        os = md.os() + md.version("Android");
        var sss = device_type.split(";");
        var i = sss.contains("Build/");
        if (i > -1) {
            model = sss[i].substring(0, sss[i].indexOf("Build/"));
        }
      }
      return [model, os, mf]
    } else {
      return ['', '', '']
    }
  },

  /**
  * 获取手机的网络类型
  */
  getNetworkType() {
    var ua = navigator.userAgent;
    var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
    networkStr = networkStr.toLowerCase().replace('nettype/', '');
    var networkType;
    switch (networkStr) {
      case 'wifi':
        networkType = 'wifi';
        break;
      case '4g':
        networkType = '4g';
        break;
      case '3g':
        networkType = '3g';
        break;
      case '3gnet':
        networkType = '3g';
        break;
      case '2g':
        networkType = '2g';
        break;
      default:
        networkType = 'other';
    }
    return [networkStr]
  }
}
 
 